export default "__VITE_ASSET__CFI7UeGM__"